<template>
  <div class="formContainer">
    <span style="color: white"
      >{{ $t("personalArea.extArea.haveCode") }}
      <template v-if="code.length">
        ({{ typedMsg }} {{ $t("typed") }})
      </template>
    </span>
    <fieldset class="fieldInput">
      <input
        class="form-input"
        type="text"
        :placeholder="$t('personalArea.extArea.codeNum')"
        v-model="code"
        @keyup.enter="updateLic"
        @input="updateTyped"
      />
      <!-- <span class="text-gray">{{ typedMsg }}</span> -->
      <button type="submit" class="form-submit code-enter" @click="updateLic">
        <b>{{ $t("general.confirm") }}</b>
      </button>
    </fieldset>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import menuService from "@/services/menu";
import { updateLicense } from "@/services/offline/license.js";
import { doHardReload } from "@/services/bookData.js";

export default {
  data() {
    return {
      routeBackName: "help",
      code: "",
      codeTyped: 0,
    };
  },
  props: {
    arrow: { default: true },
  },
  computed: {
    typedMsg() {
      return this.codeTyped === 0
        ? ""
        : this.codeTyped + " " + this.$t("about.characters");
    },
  },
  methods: {
    updateLic() {
      if (!this.code) return;
      let message = "",
        type = "";
      let packageChange =
        this.code.toLowerCase().indexOf("a0") > -1
          ? this.$t("about.refreshNow")
          : "";

      updateLicense(this.code).then((res) => {
        if (res) {
          menuService.closeMenu();
          type = "success";
          message = this.$t("about.succedUpdateLicens") + packageChange;

          //refresh list if needed
          if (packageChange) doHardReload();
        } else {
          message = this.$t("about.errorUpdate");
          type = "error";
        }
        const notification = {
          type,
          message,
          timeout: 3000,
        };
        this.$notify(notification);
      });
    },
    updateTyped($event) {
      this.codeTyped = $event.target.value.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.formContainer {
  padding: 15px;
  background-color: var(--custom-color1);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.fm {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  border-width: 0px;
}
.mainTitle {
  font-family: "Open Sans";
  text-align: center;
  margin: 30px auto;
}
.fieldInput::placeholder {
  color: white;
}

.fieldInput {
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--custom-color1);
  padding: 15px;
  background: rgba(255, 255, 255, 0.2);
  position: relative;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.09);
  border-radius: 35px;
  overflow: hidden;
  width: 280px;
  color: white;
  border: transparent;
  .form-input::placeholder {
    color: white;
  }
  .form-input {
    width: calc(100% - 50px);
    background: none;
    border: none;
    color: white;
    // padding: 12px 20px;
    // font-size: 9px;
    // color: #6a7c92;
    &:focus {
      outline: none;
    }
  }
  .form-submit::placeholder {
    color: #6a7c92;
  }
  .form-submit {
    color: var(--custom-color1);
    font-size: 12px;
    // color: #6a7c92;
    background: #fff;
    height: 100%;
    width: 65px;
    position: absolute;
    left: 0;
    border-radius: 17px;
    border: none;

    box-shadow: 5px -2px 81px 1px rgba(0, 0, 0, 0.09);
    cursor: pointer;
  }
}

.footer {
  font-family: "Open Sans";
  text-align: center;
  font-size: 12px;
  color: #6a7c92;
}
</style>
